export let tenantLogoTooltip = "qnxxle";
export let shyHeaderAriaLabel = "i7WhP";
export let appLauncherButtonLabel = "Pup3Ue";
export let overflowMenuButtonTooltip = "ec$t9";
export default {tenantLogoTooltip,shyHeaderAriaLabel,appLauncherButtonLabel,overflowMenuButtonTooltip};